import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) => ({
  actionButton: {
    margin: '0 0 0.5rem',
    padding: '0.75rem 0.5rem',
  },
  arrow: {
    '& svg': {
      transform: 'scale(1.2)',
    },
    '&:hover, &:focus': {
      cursor: 'pointer',
      outline: 'none',
    },
    alignItems: 'center',
    backgroundColor: 'transparent',
    border: '0',
    boxSizing: 'border-box',
    display: 'inline-flex',
    fontSize: '0.875rem',
    fontWeight: '500',
    justifyContent: 'center',
    lineHeight: '1.75',
    minWidth: '64px',
    padding: '17px 8px',
    verticalAlign: 'middle',
  },
  arrowDisabled: {
    '&:hover, &:focus': {
      cursor: 'not-allowed',
    },
    opacity: '0.25',
  },
  isDetailTimeline: {
    '& $timelineList': {
      height: '80px',
    },
    [theme.breakpoints.up('md')]: {
      right: 'calc((100% - 900px) / 2) !important',
    },
  },
  isMobile: {
    backgroundColor: `rgb(${theme.palette.black}) !important`,
    boxShadow: `0px 4px 10px rgb(${theme.palette.black})`,
    right: 0,
  },
  timeline: {
    // backgroundColor: 'transparent',
    backgroundColor: `rgb(${theme.palette.black})`,
    boxShadow: `0px 4px 10px rgb(${theme.palette.black})`,
    position: 'absolute',
    right: 0,
    textAlign: 'center',
    width: '64px',
    zIndex: 9999,
  },
  timelineButton: {
    '&:hover, &:focus': {
      color: `rgb(${theme.palette.white})`,
    },
    color: `rgb(${theme.palette.silver})`,
    fontSize: '0.65rem',
    transition: `color ${theme.transitions.duration.shorter}ms ${theme.transitions.easing.easeIn}`,
  },
  timelineFandom: {
    backgroundColor: `rgba(${theme.palette.black}, 0.75)`,
    position: 'fixed',
    right: 0,
    top: '60%',
    [theme.breakpoints.up('md')]: {
      backgroundColor: 'transparent',
      right: '0.5rem',
      top: '300px',
    },
  },
  timelineList: {
    listStyleType: 'none',
    margin: 0,
    position: 'relative',
  },
  timelineListButton: {
    fontSize: '0.65rem',
  },
  timelineListItem: {
    '&.first, &.last': {
      '& a': {
        color: `rgba(${theme.palette.silver}, 0.25)`,
        transform: 'scale(1)',
      },
    },
    '&.second': {
      color: `rgba(${theme.palette.silver}, 0.5)`,
      transform: 'scale(1.2)',
    },
    margin: '0.25rem 0',
    transition: `translateY ${theme.transitions.duration.shorter}ms ${theme.transitions.easing.easeIn}`,
    [theme.breakpoints.up('sm')]: {
      margin: '1rem 0',
    },
  },
  timelineListItemActive: {
    '& a': {
      fontWeight: 700,
      transform: 'scale(1.7)',
    },
  },
  timelineListItemInsideFandom: {
    display: 'none',
  },
}))
